import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "accept", "multiple"]
const _hoisted_2 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("label", {
    tabindex: "0",
    class: _normalizeClass(["py-2 px-4 transition-colors hover:bg-blue-50 text-blue-500 rounded select-none flex items-center text-center justify-center font-medium cursor-pointer", { 'cursor-not-allowed opacity-50': _ctx.disabled }])
  }, [
    _createElementVNode("input", {
      type: "file",
      hidden: "",
      disabled: _ctx.disabled || _ctx.loading,
      accept: _ctx.accept,
      multiple: _ctx.multiple,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitUpdate && _ctx.emitUpdate(...args)))
    }, null, 40, _hoisted_1),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          class: "primary"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.iconClass)
          }, null, 2),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.computedPlaceholder), 1)
        ], 64))
  ], 2))
}